import axios from "axios";
import { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesLeft,
  faCheck,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import urls from "../urls";
import formatDateDZ from "../utils/formatDate";
import { showError, showSuccess } from "../utils/notifications";
import _ from "lodash";
class ServiceApplications extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      tableData: [],
    };
    this.status = {
      pending: "قيد المعالجة",
      approved: "تمّ قبول الطلب",
      rejected: "تمّ رفض الطلب",
      served: "تمّ إستلام الطلب",
      confirmed: "تمّ تسليم الطلب في إنتظار تأكيد المستخدم",
    };
  }
  componentDidMount() {
    const { uuid } = this.props;
    console.log(uuid);
    axios.get(urls.getRequestedServices(uuid)).then((res) => {
      const { results } = res.data;

      this.setState({ tableData: results });
    });
  }
  delete = (serviceId) => {
    const { tableData } = this.state;

    axios
      .delete(urls.deleteService(serviceId))
      .then((res) => {
        const state = _.filter(tableData, (obj) => obj.id != serviceId);
        this.setState({ tableData: state });
        showSuccess("تم حذف الطلب بنجاح ");
      })
      .catch((err) => {
        console.log(err);
        showError("لم  يتم حذف الطلب بنجاح ");
      });
  };
  confirmServed = (orderId) => {
    axios
      .put(urls.confirmOrder, {
        data: { orderId, orderStatus: "served" },
      })
      .then((res) => {
        showSuccess("تم تأكيد الأستلام");
      })
      .catch((err) => {
        showError("لم يتم تأكيد الاستلام ");
      });
  };
  render() {
    const { tableData } = this.state;
    const status = this.status;
    return (
      <div className="container-fluid mt-3">
        {tableData.length > 0 ? (
          tableData.map((obj, idx) => (
            <div className="row border-bottom">
              <div className="col-1">
                <h6>{idx + 1}</h6>
              </div>
              <div className="col-8">
                <p className="text-wrap text-center">
                  {obj.service_description}
                </p>
                <p
                  className="text-muted   text-center"
                  style={{ fontSize: "10px" }}
                >
                  {formatDateDZ(obj.request_date)}
                </p>
              </div>
              <div className="col-1 text-center">
                <span className="text-center">
                  {" "}
                  حالة الطلب
                  <br />
                  <strong className="text-success">
                    {status[obj.service_status]}
                  </strong>
                </span>
              </div>
              <div className="col-1 text-center">
                {!["served", "pending"].includes(obj.service_status) && (
                  <button
                    className="btn  text-success"
                    onClick={() => this.confirmServed(obj.order_id)}
                    title="تأكيد إستلام الطلب"
                  >
                    <FontAwesomeIcon icon={faCheck} size="xl" />
                  </button>
                )}
              </div>
              <div className="col">
                {obj.service_status != "served" && (
                  <button
                    className="btn  text-danger"
                    onClick={() => this.delete(obj.id)}
                    title="حذف الطلب "
                  >
                    <FontAwesomeIcon icon={faTrashCan} size="xl" />
                  </button>
                )}
              </div>
            </div>
          ))
        ) : (
          <div
            className="text-center mt-4 p-4"
            style={{ height: "70vh", width: "95vw" }}
          >
            <h3>لا توجد أيّ طلبات </h3>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({
  uuid: state.userState.uuid,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceApplications);
